/* eslint-disable import/no-default-export */
import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"
import isoWeek from "dayjs/plugin/isoWeek"
import quarterOfYear from "dayjs/plugin/quarterOfYear"
import utc from "dayjs/plugin/utc"

dayjs.extend(customParseFormat)
dayjs.extend(isoWeek)
dayjs.extend(quarterOfYear)
dayjs.extend(utc)

export default dayjs
